import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { DropDownOption } from './styles';
import { useOutsideClick } from '../../../hooks';

const OptionsContainer = ({
  isOpen,
  children,
  onClose = () => {},
  isMenu = false,
  borderColor = 'midDarkGray',
  width = '100%'
}) => {
  const listRef = useRef(null);

  /**
   * La funcion habilita el cierre de las opciones cuando hacemos click por fuera del contenedor.
   */
  const onCloseDropDown = () => {
    if (isOpen) {
      onClose(false);
    }
  };
  useOutsideClick(listRef, onCloseDropDown);

  return (
    <DropDownOption
      ref={listRef}
      isOpen={isOpen}
      isMenu={isMenu}
      onClick={() => onCloseDropDown()}
      borderColor={borderColor}
      width={width}
    >
      {children}
    </DropDownOption>
  );
};

OptionsContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export default OptionsContainer;
